export const LetterheadDetailFragment = gql`
  fragment LetterheadDetailFragment on Letterhead {
    id
    uuid
    backgroundColor
    centerFile {
      ...FileFragment
    }
    centerFileWidthPx
    centerText
    isDefaultForOrganization
    leftText
    name
    organization {
      id
    }
    rightText
    updatedAt
  }
`
